import usePagination from './usePagination';

export default usePagination;
